import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import TenantEdit from '../components/tenant/TenantEdit';
import { PageTitle } from '../components/common/PageTitle';

const TenantEditPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={0}>
            <PageTitle title="テナント編集" />
            <TenantEdit />
        </CommonPage>
    )
}

export default TenantEditPage;